import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FloorPlanEditor } from '../../components/floor-plan';
import { useAuth } from '../../services/contexts/authContext';
import { canEditFloorPlan } from '../../components/floor-plan/constants';
import { managementFloorUrl } from './urls';

const ManagementFloorPlanEditPage = () => {
  const { branchId, buildingId, floorId } = useParams();
  const navigate = useNavigate();
  const { userDetails } = useAuth();

  const goBack = () => {
    navigate(managementFloorUrl(branchId, buildingId, floorId));
  };

  if (!canEditFloorPlan(userDetails?.role)) {
    return (
      <div className="m-4 md:m-6 flex flex-col items-center justify-center py-24 text-center">
        <p className="text-sm text-gray-800">You don&apos;t have permission to edit layouts.</p>
        <button
          type="button"
          className="mt-4 text-xs text-gray-500 underline underline-offset-2 hover:text-gray-800"
          onClick={goBack}
        >
          Go back
        </button>
      </div>
    );
  }

  return (
    <div className="m-3 rounded-3xl border border-gray-200 bg-white px-3 py-3 md:m-5 md:px-5 md:py-4">
      <FloorPlanEditor
        floorId={floorId}
        onBack={goBack}
        onDone={goBack}
      />
    </div>
  );
};

export default ManagementFloorPlanEditPage;
